/**
 * Anti-CSRF support for the AJAX layer.
 *
 * The server exposes the token through the LUX_CSRF_TOKEN cookie (see ClcmCsrfTokenManager) and
 * expects it back in the X-CSRF-Token header on every state changing request. Registering a single
 * jQuery prefilter covers every call site at once, including the FormData/multipart uploads.
 *
 * The token is deliberately never attached to cross origin requests (for instance the feedback
 * endpoint), so it cannot leak to a third party.
 */

const COOKIE_NAME = 'LUX_CSRF_TOKEN';
const HEADER_NAME = 'X-CSRF-Token';
const SAFE_METHODS = /^(?:GET|HEAD|OPTIONS|TRACE)$/i;

// @Private
const readToken = function () {
  const match = document.cookie.match(new RegExp('(?:^|;\\s*)' + COOKIE_NAME + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : null;
};

// @Private
const isSameOrigin = function (url) {
  if (!url) return true;

  // Protocol relative or absolute URL: compare the resolved origin with the current one.
  if (/^https?:\/\//i.test(url) || url.indexOf('//') === 0) {
    const anchor = document.createElement('a');
    anchor.href = url;
    return anchor.protocol === window.location.protocol && anchor.host === window.location.host;
  }

  return true;
};

/**
 * Installs the prefilter on the given jQuery instance.
 *
 * Must be called once per jQuery instance: the webpad page ships its own copy of jQuery
 * (webpad/js/frameworks/require-jquery.js) which is distinct from the one bundled by webpack.
 *
 * @param {object} jq jQuery instance
 */
export default function installCsrfProtection(jq) {
  if (!jq || !jq.ajaxPrefilter || jq.__csrfInstalled) return;
  jq.__csrfInstalled = true;

  jq.ajaxPrefilter(function (options) {
    if (SAFE_METHODS.test(options.type || options.method || 'GET')) return;
    if (!isSameOrigin(options.url)) return;

    const token = readToken();
    if (!token) return;

    options.headers = options.headers || {};
    if (!options.headers[HEADER_NAME]) {
      options.headers[HEADER_NAME] = token;
    }
  });
}
